import { axiosApi } from "../axios/axios_config";

export async function getTraceaware() {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const studyNumber = localStorage.getItem("studyNumber");
  
  let endpoint = `traceaware?userId=${userInfo.id}`;

  if(studyNumber){
    endpoint += `&studyNumber=${studyNumber}`;
  }
  
  try {
    const { data, response } = await axiosApi({
      endpoint: endpoint,
      method: "GET",
      bodyData: null,
    });
    return { data, response };
  } catch (err) {
    console.log(err.message);
    throw err;
  }
}
